import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const DashboardQuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      label: 'Beregn bomkostnader',
      description: 'Planlegg rute og optimaliser kostnader',
      icon: 'Calculator',
      path: '/toll-calculator',
      color: '#004F98',
    },
    {
      label: 'Abonnement',
      description: 'Håndter betalinger og kjøretøy',
      icon: 'CreditCard',
      path: '/subscription-portal',
      color: '#FF5722',
    },
    {
      label: 'Bomhistorikk',
      description: 'Se dine tidligere passeringer',
      icon: 'History',
      path: '/toll-history',
      color: '#6366F1',
    },
    {
      label: 'Kontakt oss',
      description: 'Få hjelp fra kundeservice',
      icon: 'MessageCircle',
      path: '/contact',
      color: '#10B981',
    },
  ];

  return (
    <div className="dashboard-quick-actions">
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px' }}>
        <div style={{ width: '18px', height: '2px', background: 'var(--color-accent)', flexShrink: 0 }} />
        <h3
          style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '13px',
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'var(--color-foreground)',
            margin: 0,
          }}
        >
          Hurtighandlinger
        </h3>
      </div>
      {/* 2×2 Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        {quickActions?.map((action) => (
          <button
            key={action?.path}
            onClick={() => navigate(action?.path)}
            aria-label={action?.label}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '8px',
              padding: '12px 14px',
              background: 'var(--color-muted)',
              border: '1.5px solid var(--color-border)',
              borderRadius: 'var(--radius-sm)',
              cursor: 'pointer',
              transition: 'all 180ms cubic-bezier(0.22,1,0.36,1)',
              textAlign: 'left',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = action?.color;
              e.currentTarget.style.background = `${action?.color}0D`;
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 6px 20px ${action?.color}25`;
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'var(--color-border)';
              e.currentTarget.style.background = 'var(--color-muted)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            onMouseDown={e => { e.currentTarget.style.transform = 'scale(0.97)'; }}
            onMouseUp={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
          >
            {/* Icon */}
            <div
              style={{
                width: '34px',
                height: '34px',
                borderRadius: '8px',
                background: `${action?.color}18`,
                border: `1.5px solid ${action?.color}35`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Icon name={action?.icon} size={17} color={action?.color} />
            </div>

            {/* Text */}
            <div>
              <div
                style={{
                  fontFamily: 'var(--font-heading)',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: 'var(--color-foreground)',
                  marginBottom: '2px',
                  lineHeight: 1.3,
                }}
              >
                {action?.label}
              </div>
              <div
                style={{
                  fontFamily: 'var(--font-caption)',
                  fontSize: '11px',
                  color: 'var(--color-muted-foreground)',
                  lineHeight: 1.4,
                }}
              >
                {action?.description}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default DashboardQuickActions;